import CustomerOrderViewPage from "./CustomerOrderViewPage.vue";

export {CustomerOrderViewPage}
export default CustomerOrderViewPage
